export const SHOP = {
  name: "Randy's Barber Shop",
  legalName: "Randy's Barbershop Inc.",
  established: 1973,
  tagline: "Where tradition meets style and everyone leaves like family",
  street: "1439 Wyoming Blvd. NE",
  cityStateZip: "Albuquerque, NM 87112",
  mapUrl: "https://goo.gl/maps/LGaQrzgE6eFyz8zq7",
  twitchChannel: "randysbarbershop",
};

/** Shop line first — that's the number on the Google listing. */
export const PHONES = [
  { label: "Shop", number: "(505) 296 - 9284", href: "tel:5052969284" },
  { label: "Big RJ", number: "(505) 974 - 8081", href: "tel:5059748081" },
];

export const BOOKINGS = [
  {
    barber: "Big RJ",
    url: "https://calendly.com/rj-the-barber/haircuts",
    promise: "30 minute guarantee",
  },
];

/** Drew cuts past the posted shop hours. */
export const LAST_CALL = {
  barber: "Drew",
  headline: "The grind doesn't stop, and neither does Drew",
  body:
    "Designer cuts for you by Drew. " +
    "Get off at 5:00? No worries — his last cut is 6:30 pm.",
  cta: "Call now to save your spot",
  bookingUrl: "https://calendly.com/drews-cuts",
};

export const HOURS_NOTE =
  "Drew cuts late — last cut 6:30 pm. Call ahead to save your spot.";

export type Service = {
  name: string;
  price: number;
  note: string;
  feature?: boolean;
};

export const SERVICES: Service[] = [
  {
    name: "Haircut",
    price: 30,
    note: "The old fashioned gentleman's cut",
    feature: true,
  },
  {
    name: "Hot Shave",
    price: 30,
    note: "Straight razor, hot lather, hot towels",
  },
  {
    name: "Beard Trim",
    price: 15,
    note: "Line up, shape up, and detail work",
  },
  {
    name: "Razor Fade",
    price: 35,
    note: "Skin tight fade finished with a razor",
  },
  {
    name: "Designer Haircut",
    price: 40,
    note: "Long hair, layers, and custom designs",
  },
];

export const PRICING_FOOTNOTE =
  "A $2 charge is added to credit card transactions.";

export const HOURS = [
  { day: "Sunday", open: "Closed" },
  { day: "Monday", open: "8:30 am - 5:00 pm" },
  { day: "Tuesday", open: "8:30 am - 5:00 pm" },
  { day: "Wednesday", open: "8:30 am - 5:00 pm" },
  { day: "Thursday", open: "8:30 am - 5:00 pm" },
  { day: "Friday", open: "8:30 am - 5:00 pm" },
  { day: "Saturday", open: "7:30 am - 4:00 pm" },
];

/** The five values behind the Big RJ name. */
export const CREED = [
  {
    letter: "B",
    title: "Barbering",
    body: "Traditional skills. Modern style. Old school values. Every cut with precision.",
  },
  {
    letter: "I",
    title: "Integrity",
    body: "Honest work. Fair prices. Respect for every client who sits in the chair.",
  },
  {
    letter: "G",
    title: "Gentlemen",
    body: "Cuts for the man who takes pride in his look. Walk-ins welcome. All are family here.",
  },
  {
    letter: "R",
    title: "Respect",
    body: "For the craft. For the culture. For you. This is more than a haircut, it's a tradition.",
  },
  {
    letter: "J",
    title: "Journey",
    body: "From 1973 to today, we keep raising the standard and building community one cut at a time.",
  },
];

export type Poster = {
  src: string;
  alt: string;
  title: string;
  caption: string;
  /** Intrinsic size, so lazy-loaded frames reserve their space up front. */
  width: number;
  height: number;
  /** Rendered large, leading the wall. */
  feature?: boolean;
};

/** Shop artwork, hung like the framed pictures in the emblem. */
export const POSTERS: Poster[] = [
  {
    src: "/assets/randys-r-emblem.jpg",
    alt: "Illustrated letter R containing a barber chair, barber pole, an adobe mission at sunset and a flamed hot rod",
    title: "Proudly Serving New Mexico",
    caption: "One cut at a time, established 1973",
    width: 800,
    height: 853,
    feature: true,
  },
  {
    src: "/assets/posters/services.jpg",
    alt: "Poster with a mustached skull over crossed razors listing Randy's services and the $30 gentleman's cut",
    title: "Old School Service",
    caption: "Real barbers, real community, real tradition",
    width: 450,
    height: 600,
  },
  {
    src: "/assets/posters/community.jpg",
    alt: "Illustrated poster of Big RJ surrounded by clients in front of the Albuquerque skyline",
    title: "Our Community, Our Family",
    caption: "We fade all hair types — kids, adults, seniors",
    width: 400,
    height: 600,
  },
  {
    src: "/assets/posters/creed.jpg",
    alt: "Poster of Big RJ with the B-I-G-R-J creed spelled out beside him",
    title: "Big RJ, Master Barber",
    caption: "Barbering, integrity, gentlemen, respect, journey",
    width: 400,
    height: 600,
  },
];

export const MARQUEE = [
  "Fades",
  "Beards",
  "Hot Towels",
  "Shaves",
  "Good Vibes",
  "Walk-Ins Welcome",
  "Est. 1973",
];
